import styled from "styled-components";

export const Wrapper = styled.div`
  .breadcrumb {
    background: transparent;

    border-radius: 0%;
    padding: 10px 0px 10px 5px;
    margin: 0;
  }

  .breadcrumb-item {
    color: var(--primary-label-color) !important;
    padding: 0;
    text-decoration: none;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .breadcrumb-item.active {
    color: #ffffff !important;
  }
  
  .breadcrumb-item.active::before {
    color: #A9A9A9!important;
  }

  .breadcrumb-item:hover {
    color: #fff;
  }

  .breadcrumb-item::before {
    color: #A9A9A9;
  }
  .wrapper {
    width: 100%;
    background: var(--info-color);
  }
  .container {
    max-width: 1024px;
    margin: auto;
  }
   @media (max-width: 767px) {
    .container-sm, .container {
    }
}
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
    }
  }

`;
